import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/inmobiliaria/fases';
import Fases from './fases';


const ms2p = (state) => {
  return {
    ...state.fase,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Fases);
